// eslint-disable-next-line no-shadow
export enum BasicButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  DISABLED = 'disabled',
  INFO = 'info',
  WHITE = 'white',
  FLAG = 'flag',
}

export enum BasicButtonSizes {
  EXTRALARGE = 'extralarge',
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum BasicButtonDensityEnum {
  DEFAULT = 'default',
  COMFORTABLE = 'comfortable',
  COMPACT = 'compact',
}

export enum BasicButtonModes {
  OUTLINED = 'outlined',
  FILLED = 'filled',
  FLAT = 'flat',
}

export enum BasicButtonTooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum IconModes {
  OUTLINED = 'outlined',
  FILLED = 'filled',
  TWO_TONE = 'two-tone',
  ROUNDED = 'rounded',
  SHARP = 'sharp',
}

export enum OptionListXPosition {
  BEFORE = 'before',
  AFTER = 'after',
}
export enum OptionListYPosition {
  ABOVE = 'above',
  BELOW = 'below',
}
